import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES, getRegisterUrl } from '../routes';

export default function QRPage() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const url = getRegisterUrl();

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleDownload = () => {
    const svg = document.getElementById('qr-svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    canvas.width = 400; canvas.height = 400;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => { ctx.drawImage(img, 0, 0); canvas.toBlob(b => { const a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = 'medicare-qr.png'; a.click(); }); };
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  return (
    <section className="form-section page-content">
      <div style={{maxWidth:'520px',margin:'0 auto'}}>
        <div className="form-card" style={{textAlign:'center'}}>
          <div style={{marginBottom:'28px'}}>
            <div style={{width:'56px',height:'56px',background:'linear-gradient(135deg,#0ea5e9,#8b5cf6)',borderRadius:'16px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.8rem',margin:'0 auto 16px',boxShadow:'0 8px 24px rgba(14,165,233,0.3)'}}>📱</div>
            <h2 style={{fontFamily:'Outfit',fontSize:'1.5rem',fontWeight:700,marginBottom:'8px',color:'var(--text-primary)'}}>Scan to Report ADR</h2>
            <p style={{color:'var(--text-secondary)',fontSize:'0.9rem'}}>
              Share this QR code with patients. Scanning it opens the ADR self-reporting form directly.
            </p>
          </div>

          <div style={{
            display:'inline-block',
            padding:'24px',
            background:'#fff',
            borderRadius:'20px',
            boxShadow:'0 0 40px rgba(14,165,233,0.3)',
            marginBottom:'28px'
          }}>
            <QRCodeSVG
              id="qr-svg"
              value={url}
              size={220}
              bgColor="#ffffff"
              fgColor="#0a0f1e"
              level="H"
              includeMargin={false}
            />
          </div>

          <div style={{
            background:'var(--bg-input)',
            border:'1px solid var(--border)',
            borderRadius:'10px',
            padding:'12px 16px',
            marginBottom:'20px',
            display:'flex',
            alignItems:'center',
            gap:'10px',
            textAlign:'left'
          }}>
            <span style={{fontSize:'0.85rem',color:'var(--text-muted)',flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{url}</span>
            <button className="btn btn-outline" style={{padding:'6px 14px',fontSize:'0.78rem',flexShrink:0}} onClick={handleCopy}>
              {copied ? '✓ Copied!' : '📋 Copy'}
            </button>
          </div>

          <div style={{
            background:'rgba(14,165,233,0.07)',
            border:'1px solid rgba(14,165,233,0.15)',
            borderRadius:'12px',
            padding:'16px',
            marginBottom:'24px',
            textAlign:'left'
          }}>
            <div style={{fontSize:'0.75rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.08em',color:'var(--primary)',marginBottom:'10px'}}>How to use</div>
            {['Open your phone camera','Point it at the QR code','Tap the link that appears','Fill in your ADR report'].map((s,i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'8px',fontSize:'0.85rem',color:'var(--text-secondary)'}}>
                <span style={{width:'22px',height:'22px',background:'rgba(14,165,233,0.2)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.7rem',fontWeight:700,color:'var(--primary)',flexShrink:0}}>{i+1}</span>
                {s}
              </div>
            ))}
          </div>

          <div style={{display:'flex',gap:'12px',justifyContent:'center',flexWrap:'wrap'}}>
            <button className="btn btn-primary" onClick={handleDownload}>⬇ Download QR Code</button>
            <button className="btn btn-secondary" onClick={() => navigate(ROUTES.REGISTER_PERSONAL)}>📋 Open Form</button>
            <button className="btn btn-outline" onClick={() => window.print()}>🖨 Print</button>
          </div>
        </div>

        <div style={{marginTop:'20px',textAlign:'center',fontSize:'0.8rem',color:'var(--text-muted)'}}>
          💡 Tip: Print and display this QR code at reception for easy patient access.
        </div>
      </div>
    </section>
  );
}
